export default {
    setRequestError(state, payload){
      state.request_error = payload.message;
    },
    setProducts(state, payload) {
      state.products_of_search = payload;
    },
    setProduct(state, payload) {
      state.product = payload;
    }
  };